import { Button, Grid, Paper } from '@mui/material';
import { Outlet } from 'react-router-dom';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { AddCircle } from '@mui/icons-material';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { useEventContext } from 'src/shared/contexts/eventContext';
import { EventCreateModal } from '../components/eventCreateModal';

export const EventsPage = () => {
  const { t } = useTranslation();
  const { setEvent, setSelectedEventType, setUploadedImageFile, setUploadedImageUrl } = useEventContext();

  const [createMode, setCreateMode] = useState<boolean>(false);

  const pageTabs: PageTabItem[] = [
    {
      label: 'event:pageTabs.overview',
      route: RoutesEnum.Events,
    },
    {
      label: 'event:pageTabs.calendar',
      route: RoutesEnum.EventsCalendar,
    },
  ];

  const onCloseHandler = () => {
    setCreateMode(false);
    setEvent(undefined);
    setSelectedEventType(undefined);
    setUploadedImageFile(undefined);
    setUploadedImageUrl('');
  };
  const onSaveHandler = () => {
    setCreateMode(false);
    setEvent(undefined);
    setSelectedEventType(undefined);
    setUploadedImageFile(undefined);
    setUploadedImageUrl('');
  };

  return (
    <>
      <GridWrapper>
        <Grid item xs={12} md={4}>
          <MainContentHeader title={t('event:events')} />
        </Grid>
        <Grid item xs={12} md={8} style={{ display: 'flex', justifyContent: 'flex-end', gridColumnGap: '5px' }}>
          <Button onClick={() => setCreateMode(true)} variant='contained' color='primary' startIcon={<AddCircle />} disableElevation>
            {t('event:newEvent')}
          </Button>
        </Grid>
        <Grid item xs={12} sx={{ mb: 0 }} />
      </GridWrapper>
      <GridWrapper>
        <Grid item xs={12}>
          <Paper>
            <PageTabNavigation pageTabs={pageTabs} />
            <Outlet />
          </Paper>
        </Grid>
      </GridWrapper>
      {createMode && <EventCreateModal onClose={onCloseHandler} onSave={onSaveHandler} modalOpen={createMode} />}
    </>
  );
};
